import styled from 'styled-components';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';
import { VisuallyHidden } from '../../../../ui-components/utils.styles';

export const StyledCategories = styled.div`
    margin-top: 1.5em;
`;

export const CategoryHeading = styled.h2`
    ${VisuallyHidden}
`;

export const CategoryList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const Category = styled.li`
    display: inline-block;
    margin-right: 15px;
`;

export const CategoryLink = styled.a`
    ${PlayTextStyles}
    line-height: 1.8;
    text-decoration: underline;
`;
